import messages from './messages.json';

const getEmailSuggestionFormatter = (intl) => (email) => intl.formatMessage(
  messages.emailSuggestion,
  { email },
);

export default getEmailSuggestionFormatter;
